
// Sample data for energy consumers

export const topConsumers = [
  {
    name: "Tech Park North",
    location: "2350 Innovation Drive",
    consumption: 28750,
    change: 1.8
  },
  {
    name: "Metropolitan Hospital",
    location: "185 Healthcare Avenue",
    consumption: 22680,
    change: -2.3
  },
  {
    name: "State University Campus",
    location: "800 Knowledge Boulevard",
    consumption: 19450,
    change: 3.5
  },
  {
    name: "Skyline Tower Offices",
    location: "410 Business Center Road",
    consumption: 17320,
    change: -1.2
  },
  {
    name: "Shopping Mall Plaza",
    location: "95 Retail Avenue",
    consumption: 15830,
    change: 0.7
  }
];

// Sample data for defaulter consumers
export const defaulterConsumers = [
  {
    name: "Riverfront Manufacturing",
    accountId: "ENE-28759",
    location: "725 Industrial Parkway",
    outstandingAmount: 42680,
    daysOverdue: 78,
    status: "Critical"
  },
  {
    name: "Eastside Shopping Center",
    accountId: "ENE-19384",
    location: "1204 Retail Boulevard",
    outstandingAmount: 27490,
    daysOverdue: 45,
    status: "High"
  },
  {
    name: "Summit Office Park",
    accountId: "ENE-73291",
    location: "350 Corporate Drive",
    outstandingAmount: 18750,
    daysOverdue: 32,
    status: "Medium"
  },
  {
    name: "Valley View Apartments",
    accountId: "ENE-54712",
    location: "893 Residential Lane",
    outstandingAmount: 12480,
    daysOverdue: 21,
    status: "Medium"
  },
  {
    name: "Central Medical Plaza",
    accountId: "ENE-67024",
    location: "475 Healthcare Avenue",
    outstandingAmount: 9350,
    daysOverdue: 15,
    status: "Low"
  }
];

// Sample data for all energy consumers
export const allEnergyConsumers = [
  {
    name: "Tech Park North",
    accountId: "ENE-28759",
    type: "Commercial",
    location: "2350 Innovation Drive",
    usage: 28750,
    status: "Active"
  },
  {
    name: "Metropolitan Hospital",
    accountId: "ENE-19384",
    type: "Institutional",
    location: "185 Healthcare Avenue",
    usage: 22680,
    status: "Active"
  },
  {
    name: "State University Campus",
    accountId: "ENE-73291",
    type: "Institutional",
    location: "800 Knowledge Boulevard",
    usage: 19450,
    status: "Active"
  },
  {
    name: "Skyline Tower Offices",
    accountId: "ENE-54712",
    type: "Commercial",
    location: "410 Business Center Road",
    usage: 17320,
    status: "Active"
  },
  {
    name: "Shopping Mall Plaza",
    accountId: "ENE-67024",
    type: "Commercial",
    location: "95 Retail Avenue",
    usage: 15830,
    status: "Active"
  },
  {
    name: "Riverfront Manufacturing",
    accountId: "ENE-28759",
    type: "Industrial",
    location: "725 Industrial Parkway",
    usage: 12680,
    status: "Inactive"
  },
  {
    name: "Valley View Apartments",
    accountId: "ENE-54712",
    type: "Residential",
    location: "893 Residential Lane",
    usage: 8970,
    status: "Active"
  },
  {
    name: "Central Medical Plaza",
    accountId: "ENE-67024",
    type: "Institutional",
    location: "475 Healthcare Avenue",
    usage: 7850,
    status: "Active"
  },
  {
    name: "Westside Data Center",
    accountId: "ENE-34192",
    type: "Industrial",
    location: "175 Server Road",
    usage: 6940,
    status: "Active"
  },
  {
    name: "Highland Residential Complex",
    accountId: "ENE-92837",
    type: "Residential",
    location: "450 Mountain View Drive",
    usage: 6320,
    status: "Active"
  },
  {
    name: "Downtown Hotel",
    accountId: "ENE-47651",
    type: "Commercial",
    location: "295 Visitor Avenue",
    usage: 5870,
    status: "Active"
  },
  {
    name: "City Convention Center",
    accountId: "ENE-63018",
    type: "Municipal",
    location: "500 Event Boulevard",
    usage: 5340,
    status: "Active"
  }
];
